import type { IconName } from "@-/dev.improve.haniverse.components.ui.icon";

/**
 * A toggle in a section header's trailing edge, beside (or instead of) the collapse chevron.
 * Native headers hit-test these strips themselves (see `StickyAccordionHeader.actions`).
 */
export type SectionAccordionHeaderAction = {
  iconName: IconName;
  label: string;
  onPress: () => void;
  selected: boolean;
};

/** Width of each action strip; the header draws each icon centered in one. */
export const SECTION_ACCORDION_HEADER_ACTION_WIDTH = 32;
/** The header content's horizontal margin (`mx-2.25`), which the last strip ends at. */
export const SECTION_ACCORDION_HEADER_TRAILING_INSET = 9;
